@use '~/theme/theme' as *;

.popoverContent {
  display: flex;
  flex-direction: column;
  gap: spacing(2);
  padding: spacing(3);
  min-width: 320px;
}
